import Converter from './Converter';
import { CasinoType, ICasinoProviderConfigurationItem } from 'modules/Casino/types/configuration';
import { projectName } from 'modules/Casino/utils/slots';
import { parseCookies } from '../../utils/parseCookies';
import { QueryTypes } from 'modules/Casino/types/enums/api';
import { languageCodes } from './utils';

const converter = new Converter();

export const config: ICasinoProviderConfigurationItem<Converter> = {
  type: CasinoType.liveCasino,
  authRequired: false,
  gameListUrl: 'api/xpg/get_game_list',
  sessionUrlData: {
    url: 'api/xpg/get_game_link',
    getQuery: params =>
      `?game_id=${params.gameId}&limitset_id=${params.game?.limitSetID || ''}&lang=${
        languageCodes[params.lang as keyof typeof languageCodes] ?? languageCodes['es-es']
      }`,
    method: QueryTypes.GET,
    converter: converter.convertGameUrl,
    getHeaders: () => ({
      headers: {
        'x-partner-authorization': parseCookies(),
        'x-partner-name': projectName,
      },
    }),
  },
  converter,
};
